/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    func, object, number, bool, string,
} from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useDispatch, useSelector } from 'react-redux';
import style from './BYOItemDetails.module.css';
import byoTheme from './BYOTheme';
import { getBrand } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import FoodDetailsExpansionPanel from '../../../GraphqlFoodDetailsUI/v2/FoodDetailsExpansionPanel';
import { trackEvent } from '../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import ResponsiveImage from '../../../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';

const BYOItemDetails = ({
    selectedOption,
    handleItemSelection,
    numberSelected,
    disabled,
    error,
    handleRemoveError,
    isCYOQtyButtonEnabled,
    stepIndex,
}) => {
    const buildImgPath = (path, name) => `${path + name}x.jpg?width=354&height=358&auto=webp`;
    useStyles(style);
    const brandData = useSelector(getBrand);
    const brandCode = brandData?.code;
    const [selectedFocus, setSelectedFocus] = useState(true);
    const dispatch = useDispatch();
    // default color assigned when no brand code found
    const {
        buttonColorSelect = '#512C1C',
    } = byoTheme[brandCode] || {};
    const {
        filledColorBg = '#512C1C',
    } = byoTheme[brandCode] || {};
    return (
        <>
            <div className={style.dialogContent}>
                <div className={style.imageContainer}>
                    {error && (
                        <p className={style.errorContainer}>
                            {error}
                        </p>
                    )}
                    <ResponsiveImage className={style.productImage} path={buildImgPath(selectedOption?.image?.path, selectedOption?.image?.name)} alt={selectedOption.name || 'productItem'} params={{ desktop: 'quality=100', tablet: 'quality=100', mobile: 'quality=100' }} />
                </div>
                <div
                    className={style.bottomContent}
                    style={{
                        '--btn-filled-color': filledColorBg,
                    }}
                >
                    <p className={style.productName}>{ReactHtmlParser(selectedOption?.name)}</p>
                    {selectedOption?.longDescription &&  <FoodDetailsExpansionPanel summary="Contents" details={ReactHtmlParser(selectedOption.longDescription)} panelId={1} expanded={!selectedOption.shortDescription} pdpInlineAddon byoLabelDesign={style.header}  />}
                    {selectedOption?.shortDescription && <FoodDetailsExpansionPanel summary="Description" details={ReactHtmlParser(selectedOption.shortDescription)} panelId={2}  expanded={selectedOption.shortDescription} pdpInlineAddon byoLabelDesign={style.header} />}
                </div>
            </div>
            <div
                className={style.buttonMainContainer}
                style={{
                    '--btn-selected-color': buttonColorSelect,
                }}
            >
                {numberSelected || !selectedFocus || isCYOQtyButtonEnabled
                    ? (
                        <button
                            color="primary"
                            id="btnAddToCart"
                            data-testid="remove-icon"
                            className={`${style.addToGiftButton} ${style.numberSelectedButton} `}
                            tabIndex={-1}
                            type="button"
                        >
                            <span className={style.delButton}>
                                <button
                                    className={style.deleteIcon}
                                    onClick={() => {
                                        handleItemSelection(-1);
                                        dispatch(trackEvent({
                                            ga_event_name: 'byo_interaction',
                                            eventCategory: 'BYO',
                                            eventAction: 'Item removed',
                                            eventLabel: selectedOption.legacyId || '',
                                            itemQuantity: numberSelected,
                                            step: stepIndex,

                                            interaction_type: 'remove_item',
                                            byo_step: stepIndex,
                                            byo_item_name: selectedOption?.name,
                                            byo_item_variant: selectedOption?.legacyId,
                                            byo_item_quantity: numberSelected,
                                        }));
                                    }}
                                    onKeyDown={() => { }}
                                    tabIndex={-1}
                                    type="button"
                                    disabled={numberSelected === 0}
                                >
                                    <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 13H5v-2h14v2z" /></svg>
                                </button>
                                <input
                                    type="text"
                                    name="email"
                                    onChange={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        const inputValue = e.target.value;
                                        if (/^\d*\.?\d*$/.test(inputValue)) {
                                            const diff = (parseInt(inputValue, 10) || 0) - numberSelected;
                                            handleItemSelection(diff, true);
                                        }
                                    }}
                                    onBlur={() => {
                                        handleRemoveError(selectedOption.legacyId);
                                        setSelectedFocus(true);
                                    }}
                                    onFocus={() => {
                                        setSelectedFocus(false);
                                    }}
                                    value={numberSelected || '0'}
                                    className={style.inputField}
                                    id={ReactHtmlParser(selectedOption)}
                                />
                                <button
                                    className={style.addIcon}
                                    onKeyDown={() => { }}
                                    tabIndex={-1}
                                    type="button"
                                    disabled={disabled}
                                    onClick={() => {
                                        handleItemSelection(1);
                                        dispatch(trackEvent({
                                            ga_event_name: 'byo_interaction',
                                            eventCategory: 'BYO',
                                            eventAction: 'Item added',
                                            eventLabel: selectedOption.legacyId || '',
                                            itemQuantity: numberSelected,
                                            stepNumber: stepIndex,

                                            interaction_type: 'add_item',
                                            byo_step: stepIndex,
                                            byo_item_name: selectedOption?.name,
                                            byo_item_variant: selectedOption?.legacyId,
                                            byo_item_quantity: numberSelected,
                                        }));
                                    }}
                                    onBlur={() => {
                                        handleRemoveError(selectedOption.legacyId);
                                    }}
                                >
                                    <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" /></svg>
                                </button>
                            </span>
                        </button>
                    ) : (
                        <button
                            color="primary"
                            id="btnAddToCart"
                            data-testid="btn-add-to-cart"
                            className={`${style.addToGiftButton} `}
                            onKeyDown={() => {}}
                            tabIndex={-1}
                            type="button"
                            disabled={disabled}
                            onBlur={() => {
                                handleRemoveError(selectedOption.legacyId);
                            }}
                            onClick={() => {
                                handleItemSelection(1);
                                dispatch(trackEvent({
                                    ga_event_name: 'byo_interaction',
                                    eventCategory: 'BYO',
                                    eventAction: 'Item added',
                                    eventLabel: selectedOption.legacyId || '',
                                    itemQuantity: numberSelected,
                                    stepNumber: stepIndex,

                                    interaction_type: 'add_item',
                                    byo_step: stepIndex,
                                    byo_item_name: selectedOption?.name,
                                    byo_item_variant: selectedOption?.legacyId,
                                    byo_item_quantity: numberSelected,
                                }));
                            }}
                        >
                            Add to Gift
                        </button>
                    )  }
            </div>
        </>

    );
};
BYOItemDetails.propTypes = {
    selectedOption: object.isRequired,
    numberSelected: number,
    handleItemSelection: func.isRequired,
    disabled: bool.isRequired,
    error: string.isRequired,
    handleRemoveError: func.isRequired,
    isCYOQtyButtonEnabled: bool,
    stepIndex: string,
};
BYOItemDetails.defaultProps = {
    numberSelected: 0,
    isCYOQtyButtonEnabled: false,
    stepIndex: null,
};
export default BYOItemDetails;
